import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

const DeleteModal = ({ show, handleHide, title, text, confirmDelete }) => {
  const { t: translator } = useTranslation();

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{text}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("File-DeleteModalButton-Close")}
        </button>
        <button
          onClick={confirmDelete}
          type="button"
          className="btn btn-primary"
        >
          {translator("File-DeleteModalButton-Delete")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
